/**
 * Mobile nav level-0: full-width left-to-right slide submenu
 * Also keeps optional variant:changed hook for theme custom.js
 */
(function () {
  if (window.__t4sMbSubSlideInit) return;
  window.__t4sMbSubSlideInit = true;

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function initVariantHook() {
    if (typeof jQuery_T4NT === "undefined") return;
    jQuery_T4NT(document).on("variant:changed", function () {
      // console.log( evt.currentVariant );
    });
  }

  function initMbSubSlide() {
    var drawer = document.getElementById("t4s-menu-drawer");
    if (!drawer) return;

    function ensureBackBtn(li) {
      var sub = li.querySelector(":scope > .t4s-sub-menu");
      if (!sub || sub.querySelector(".t4s-mb-sub-back-item")) return;

      var link = li.querySelector(":scope > a");
      var titleEl = link && link.querySelector(".nav_link_txt, .t4s-nav_link_txt");
      var title = ((titleEl && titleEl.textContent) || (link && link.textContent) || "")
        .replace(/\s+/g, " ")
        .trim();

      var item = document.createElement("li");
      item.className = "t4s-mb-sub-back-item";
      item.innerHTML =
        '<button type="button" class="t4s-mb-sub-back" data-mb-sub-back>' +
        '<span class="t4s-mb-sub-back__arrow" aria-hidden="true"></span>' +
        '<span class="t4s-mb-sub-back__label"></span>' +
        "</button>";
      item.querySelector(".t4s-mb-sub-back__label").textContent = title;
      sub.insertBefore(item, sub.firstChild);
    }

    function closeAllSubs(exceptLi) {
      drawer.querySelectorAll(".t4s-mb__menu > .t4s-menu-item.t4s-item-level-0.is--opend").forEach(function (li) {
        if (exceptLi && li === exceptLi) return;
        li.classList.remove("is--opend");
      });
      if (!drawer.querySelector(".t4s-mb__menu > .t4s-menu-item.t4s-item-level-0.is--opend")) {
        drawer.classList.remove("is--sub-open");
      }
    }

    function openSub(li) {
      ensureBackBtn(li);
      closeAllSubs(li);
      li.classList.add("is--opend");
      var sub = li.querySelector(":scope > .t4s-sub-menu");
      if (sub) {
        sub.style.display = "block";
        sub.style.height = "100%";
        sub.style.overflow = "auto";
      }
      drawer.classList.add("is--sub-open");
    }

    function closeSub(li) {
      if (li) li.classList.remove("is--opend");
      else closeAllSubs();
      if (!drawer.querySelector(".t4s-mb__menu > .t4s-menu-item.t4s-item-level-0.is--opend")) {
        drawer.classList.remove("is--sub-open");
      }
    }

    drawer.addEventListener(
      "click",
      function (e) {
        var back = e.target.closest("[data-mb-sub-back]");
        if (back) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeSub(back.closest(".t4s-item-level-0"));
          return;
        }

        var icon = e.target.closest(
          ".t4s-mb__menu > .t4s-menu-item.t4s-item-level-0.t4s-menu-item-has-children > a > .t4s-mb-nav__icon"
        );
        var link = e.target.closest(
          ".t4s-mb__menu > .t4s-menu-item.t4s-item-level-0.t4s-menu-item-has-children.t4s-only_icon_false > a"
        );

        if (!icon && !link) return;

        var li = (icon || link).closest(".t4s-item-level-0");
        if (!li || !li.querySelector(":scope > .t4s-sub-menu")) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (li.classList.contains("is--opend")) {
          closeSub(li);
        } else {
          openSub(li);
        }
      },
      true
    );

    drawer.addEventListener("closedDrawer", function () {
      closeSub();
    });
  }

  onReady(function () {
    initMbSubSlide();
    // Theme may load jQuery later; retry variant hook briefly
    var tries = 0;
    (function waitJq() {
      if (typeof jQuery_T4NT !== "undefined") {
        initVariantHook();
        return;
      }
      if (++tries < 40) setTimeout(waitJq, 100);
    })();
  });
})();
